export const DEFAULT_COOKIE_CONSENT_COPY = Object.freeze({
  title: 'Privacidade e melhoria da experiência',
  description:
    'Usamos cookies analíticos para entender navegação, melhorar fluxos da LAIS e medir estabilidade. Dados sensíveis não entram no tracking.',
  accept: 'Aceitar analytics',
  close: 'Agora não',
  policy: 'Política de cookies',
});

export const resolveCookieConsentCopy = ({ copy = {}, cta = {} } = {}) => ({
  ...DEFAULT_COOKIE_CONSENT_COPY,
  ...copy,
  accept: cta.text || copy.accept || DEFAULT_COOKIE_CONSENT_COPY.accept,
});

export const resolveCookieConsentCtaStyle = (cta = {}) => ({
  ...(cta.background ? { backgroundColor: cta.background } : {}),
  ...(cta.color ? { color: cta.color } : {}),
});
